// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

shareListModalStyles.buttonsContainer = {
    gap: 20,
};

shareListModalStyles.allowEditingGridItem = {
    width: [12, 6, 8, 6, 6],
    css: css`
        align-items: center;
    `,
};

shareListModalStyles.cancelButtonGridItem = {
    width: [12, 3, 2, 3, 3],
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            order: 1;
            min-width: 100%;
        }
    `,
};

shareListModalStyles.shareListRadio = {
    css: css`
        input {
            margin-left: 0;
        }
        white-space: nowrap;
        ${TypographyStyle} {
            white-space: normal;
        }
    `,
};

shareListModalStyles.shareListTooltip = {
    ...shareListModalStyles.shareListTooltip,
    iconProps: {
        src: AlertInfo,
        color: "primary",
        size: 14,
        css: css`
            vertical-align: text-top;
            margin-left: 3px;
        `,
    },
};

shareListModalStyles.recipientEmailTooltip = {
    ...shareListModalStyles.recipientEmailTooltip,
    iconProps: {
        src: AlertInfo,
        color: "primary",
        size: 14,
        css: css`
            vertical-align: text-top;
            margin-left: 3px;
        `,
    },
};

shareListModalStyles.shareByBillingTooltip = {
    ...shareListModalStyles.shareByBillingTooltip,
    iconProps: {
        src: AlertInfo,
        color: "primary",
        size: 14,
        css: css`
            vertical-align: text-top;
            margin-left: 3px;
        `,
    },
};

shareListModalStyles.shareByEmailTooltip = {
    ...shareListModalStyles.shareByEmailTooltip,
    iconProps: {
        src: AlertInfo,
        color: "primary",
        size: 14,
        css: css`
            vertical-align: text-top;
            margin-left: 3px;
        `,
    },
};
